import Enumerator from '../global/Enumerator';
import { HouseholdExpenseType } from './HouseholdExpense.enum';

export const householdGroups = [
  'food',
  'discretionary',
  'children_and_education',
  'health_and_wellness',
  'transport',
  'property',
  'other_commitments'
];

export class HouseholdGroup extends Enumerator {
  static default() {
    return this.of('food');
  }
}

HouseholdGroup.initEnum({
  food: {
    get title() {
      return 'Food expenses';
    },
    get types() {
      return [
        HouseholdExpenseType.food_and_supermarket.name,
        HouseholdExpenseType.coffees_lunches_takeaway.name,
        HouseholdExpenseType.cigarettes_and_alcohol.name
      ];
    }
  },
  discretionary: {
    get title() {
      return 'Discretionary expenses';
    },
    get types() {
      return [
        HouseholdExpenseType.entertainment.name,
        HouseholdExpenseType.domestic_holidays.name,
        HouseholdExpenseType.clothing_shoes_and_accessories.name,
        HouseholdExpenseType.hairdressing_and_grooming.name,
        HouseholdExpenseType.phone_internet_and_pay_tv.name,
        HouseholdExpenseType.media_streaming_and_subscription_services.name,
        HouseholdExpenseType.gifts_and_celebrations.name,
        HouseholdExpenseType.other_discretionary_expenses.name,
        HouseholdExpenseType.pets.name
      ];
    }
  },
  children_and_education: {
    get title() {
      return 'Children and education expenses';
    },
    get types() {
      return [
        HouseholdExpenseType.public_education_costs.name,
        HouseholdExpenseType.private_education_costs.name,
        HouseholdExpenseType.tertiary_and_vocational_education.name,
        HouseholdExpenseType.childcare.name
      ];
    }
  },
  health_and_wellness: {
    get title() {
      return 'Health & wellness expenses';
    },
    get types() {
      return [
        HouseholdExpenseType.gym_fees_sport_other_health_and_wellness.name,
        HouseholdExpenseType.private_health_insurance.name,
        HouseholdExpenseType.doctor_dentist_pharmacy_glasses.name,
        HouseholdExpenseType.life_trauma_income_insurance.name
      ];
    }
  },
  transport: {
    get title() {
      return 'Transport expenses';
    },
    get types() {
      return [
        HouseholdExpenseType.recreational_vehicle_running_costs.name,
        HouseholdExpenseType.essential_vehicle_running_cost.name,
        HouseholdExpenseType.public_transport_taxis_and_ride_share_commuting_airfares.name,
        HouseholdExpenseType.essential_vehicle_insurance.name
      ];
    }
  },
  property: {
    get title() {
      return 'Property expenses';
    },
    get types() {
      return [
        HouseholdExpenseType.primary_residence_running_costs.name,
        HouseholdExpenseType.primary_residence_body_corp.name,
        HouseholdExpenseType.secondary_residence_running_costs.name,
        HouseholdExpenseType.secondary_residence_body_corp.name,
        HouseholdExpenseType.investment_property_running_costs.name,
        HouseholdExpenseType.investment_property_body_corp.name
      ];
    }
  },
  other_commitments: {
    get title() {
      return 'Other commitments';
    },
    get types() {
      return [
        HouseholdExpenseType.child_or_spousal_maintenance.name,
        HouseholdExpenseType.current_rent_expense.name,
        HouseholdExpenseType.ongoing_board_expense.name
      ];
    }
  }
});

export default {
  householdGroups,
  HouseholdGroup
};
